import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {inject, Injectable} from "@angular/core";
import {AuthServiceMock} from "../auth/authentication-service-mock/auth.service.mock";
import {Observable} from "rxjs";

/**
 * Adds Authorization header with token depending on user role
 */
@Injectable()
export class MockAuthTokenInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {
    const authService = inject(AuthServiceMock);

    const mockJwt = authService.getToken();

    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${mockJwt}`
      }
    });

    return handler.handle(cloned);
  }
}
